import React, {useState,useEffect} from 'react'
import axios from 'axios'

const WeatherCountry = ({country_name}) => {
    const API_WEATHER_URL = 'https://api.openweathermap.org/data/2.5/weather?q='

    const [temp, setTemp] = useState('')
    const [wind, setWind] = useState('')
    
    useEffect(() => {
        axios
            .get(`${API_WEATHER_URL}${country_name}&appid=${process.env.REACT_APP_API_KEY}`)
            .then(response => {
                setTemp(Math.floor(response.data.main.temp - 273.15))
                setWind(response.data.wind.speed)
            })        
    }, [country_name])

    return(
        <article>
            <p><strong>Temperature:</strong> {temp ? <span>{temp} °C</span> : <span>Not data</span>}</p>
            <p><strong>Wind Speed:</strong> {wind ? <span>{wind} m/s</span> : <span>Not data</span>}</p>
            <img 
                alt=''/>
        </article>
    )
}

export default WeatherCountry